var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32985_130761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 11.3196L3.43434 6.5L8.25391 1.68042",
    stroke: "white",
    strokeOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32985_130761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 12 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLeft);
export default __webpack_public_path__ + "static/media/single_left.8cd8e26da367346aa78d170e392a334c.svg";
export { ForwardRef as ReactComponent };